import React from "react";
export default function Button(props) {
    const { value, setValue, styleClass } = props;
    return (React.createElement("span", { className: styleClass, style: { margin: "0 10px" } },
        React.createElement("button", { onClick: (e) => setValue((v) => v - 1) }, "<"),
        React.createElement("input", { type: "number", name: "version", value: value, onChange: (e) => setValue(Number(e.target.value)) }),
        React.createElement("button", { onClick: (e) => setValue((v) => v + 1) }, ">")));
}
